import { useCallback } from 'react';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
export const useOpenConnectionLogin = (_) => {
    const onOpenLogins = useCallback((_, __ = false) => {
        UnavailableOnWebModal.show('emma://broken-connections', 'Renew access');
    }, []);
    return onOpenLogins;
};
